import {Component, Input, OnInit} from '@angular/core';
import {WdrAllgemeinBericht} from "../../../../../../../model/vorhersagen/wdr-wetterbericht";

@Component({
  selector: 'app-wdr-deutschland-bericht',
  templateUrl: './wdr-deutschland-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrDeutschlandBerichtComponent{
  @Input() deutschlandBericht: WdrAllgemeinBericht;


}
